import styled from 'styled-components';

export const OrderFilterBlock = styled.div`
  display: flex;
  flex: 1;

  > div:nth-child(1) {
    max-width: 27rem;
  }

  & > button {
    width: 10.75rem;
    padding: 0;
    margin-right: 1.6rem;
    align-self: flex-end;

    :last-child {
      margin-right: 0;
    }
  }

  & > div.hefesto-datefield,
  div.select-container {
    width: 16.875rem;
  }

  & > div {
    &.order-status > .ant-select {
      width: 100%;

      & span.ant-select-selection-item > span.all {
        // esconde a bolinha no select fechado quando tiver selecionado a opção "Todos"
        display: none;
      }
    }

    &.product-type > .ant-select {
      width: 100%;
    }

    &.date-range {
      min-width: 15rem;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 96%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    .select-container {
      width: 16.875rem;
    }

    & > div:not(:last-child) {
      margin-right: 1.5rem;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    & > div {
      margin-right: 1.5rem;
    }
  }
`;

export const CollorFulBall = styled.span`
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 5px;
  margin-right: 0.5rem;
`;

export const DatefieldContainer = styled.div`
  width: auto;
`;
